import { scaleLinear, scaleBand } from 'd3-scale';

export const getAxisScaleBand = (
    domain: string[],
    rangeStart: number,
    rangeEnd: number,
    scaleBandPadding: number,
    scaleBandOuterPadding: number,
  ) => {
    return scaleBand()
      .padding(scaleBandPadding)
      .domain(domain)
      .rangeRound([rangeStart, rangeEnd])
      .paddingOuter(scaleBandOuterPadding);
  }

  export const getAxisScaleLinear = (
    domain: number[],
    rangeStart: number,
    rangeEnd: number,
    tickValues?: number[],
  ) => {
    const scale = scaleLinear().domain(domain).rangeRound([rangeStart, rangeEnd]);
    if(tickValues && tickValues.length > 0) {
      scale.ticks = () => tickValues;
    }
    return scale;
  }